(function() {
'use strict';

angular
    .module('core')
    .directive('expander', expander);

function expander($rootScope) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            title: '@',
            subtitle: '@',
            expanded: '=',
            expandable: '@',
            accordion: '@',
            accordionGroup: '@',
            headerClass: '@',
            bodyClass: '@',
            iconClassExpanded: '@',
            iconClassCollapsed: '@',
            forceHeaderClasses: '='
        },
        templateUrl: 'partials/home/directivetemplate?type=Expander',
        link(scope, el, attr) {
            scope.hClass = '';

            //set defaults for unset scope values
            if (!attr.iconClassExpanded) {
                attr.iconClassExpanded = 'icon icon-collapse';
            }

            if (!attr.iconClassCollapsed) {
                attr.iconClassCollapsed = 'icon icon-expand';
            }


            //we have to capture the expanded attribute and assign it to a new property
            //otherwise angular gets upset if the attribute is not assignable (which we as
            //a directive have no control over
            scope.$watch('expanded', function(val) {
                scope.e = val;
            });

            const accordion = attr.accordion === 'true';
            if (accordion) {
                scope.$on(String.format('{0}expanderExpanded', attr.accordionGroup ? attr.accordionGroup : ''), function(ev, s) {
                    if (scope.$id !== s.$id && scope.e) {
                        scope.toggle();
                    }
                });
            }

            scope.$on('forceExpand', function() {
                scope.e = true;
            });

            scope.toggle = function() {
                if (scope.expandable === 'false') {
                    return;
                }

                scope.e = !scope.e;
                if (scope.e) {
                    $rootScope.$broadcast(String.format('{0}expanderExpanded', attr.accordionGroup ? attr.accordionGroup : ''), scope);
                }
            };
            scope.headerClasses = function() {
                if (scope.forceHeaderClasses === true) {
                    scope.hClass = scope.headerClass == null ? '' : ` ${scope.headerClass}`;
                } else {
                    scope.hClass = '';
                }
            };
            scope.expanderClass = function() {
                if (scope.expandable === 'false') {
                    scope.headerClasses();
                    return 'ng-hide';
                }

                //update the hClass property
                scope.hClass = scope.e ? 'expanded' : 'collapsed';
                scope.hClass += scope.headerClass == null ? '' : ` ${scope.headerClass}`;

                return scope.e ? scope.iconClassExpanded : scope.iconClassCollapsed;
            };

            scope.bClass = function() {
                return scope.bodyClass == null ? '' : scope.bodyClass;
            };
        }
    };
}
})();
